import { IonIcon, IonLabel } from '@ionic/react'
import { chatboxOutline } from 'ionicons/icons'
import React from 'react'
import './CommentIcon.component.css'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import {
  setOnChangeAction,
  setCommentMaxLength,
  setCommentPageTitle,
  setCommentText,
  setSaveAction,
  setPreviousPagePath,
  setHideComments,
} from '../store/comments.actions'
import { TabConstants } from '../../tabs/Tabs.constants'
import { IPreviousPage } from '../store/comments.types'
import Validation from '../../validation/Validation.component'

interface ICommentProps {
  showLabel?: boolean
  iconColor?: string
  commentText: string
  commentPageTitle?: string
  commentMaxLength?: number
  previousPagePath?: string | IPreviousPage
  onChangeAction?: Array<string>
  saveAction?: Array<string>
  enableClick?: boolean // false when no action is needed on click
  onClick?: () => void // when different callback is needed
  className?: string
  hideComments?: boolean
  validationAction?: string
}
const CommentIcon: React.FC<ICommentProps> = ({
  showLabel = false,
  iconColor = 'zoll-darkBlue',
  commentText,
  commentPageTitle = '',
  commentMaxLength = 500,
  previousPagePath = '',
  onChangeAction = [],
  saveAction = [],
  enableClick = true,
  onClick,
  className = '',
  hideComments,
  validationAction,
}) => {
  const history = useHistory()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleClick = () => {
    if (onClick) {
      onClick()
      return
    }
    if (!enableClick) return
    dispatch(setOnChangeAction(onChangeAction))
    dispatch(setCommentText(commentText))
    dispatch(setCommentPageTitle(commentPageTitle))
    dispatch(setPreviousPagePath(previousPagePath))
    dispatch(setHideComments(hideComments))
    if (commentMaxLength) {
      dispatch(setCommentMaxLength(commentMaxLength))
    }
    if (saveAction) {
      dispatch(setSaveAction(saveAction))
    }
    history.replace(TabConstants.BODY_ASSESSMENT_COMMENTS)
  }

  return (
    <>
      <div id='common-comment-icon' className={className + ' ion-no-padding'} onClick={handleClick}>
        <div className='comment-icon-content'>
          <div className='comment-icon'>
            <IonIcon color={iconColor} size='large' icon={chatboxOutline} />
          </div>
          <div>
            <div className={commentText?.length > 0 && !hideComments ? 'icon-dot' : ''} />
            {showLabel && <IonLabel color='medium'>{t('common.Comments')}</IonLabel>}
          </div>
        </div>
      </div>
      {validationAction && <Validation id={validationAction} />}
    </>
  )
}

export default CommentIcon
